// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:08:09

export default {
  "id": "monster-makeup-3d",
  "slug": "monster-makeup-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7b08e71b06aa45f4ac02a2118ad0b055-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7b08e71b06aa45f4ac02a2118ad0b055/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Monster Makeup 3D",
      "description": "Show off your makeup skills by helping monsters blend seamlessly into human society. Protect them by keeping their true identities hidden from angry mobs. Transform monsters to hide in plain sight, ensuring their survival. Customize their look by choosing skin color, changing eye lenses, adjusting their teeth, and adding the perfect wig to complete their human disguise. But be careful—make a mistake, and you might become the monster's next meal! ",
      "instructions": "Use your mouse or drag and drop to make a perfect makeover.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "dressing",
        "girls",
        "makeover",
        "makeup"
      ]
    },
    "zh-CN": {
      "title": "怪物化妆3D",
      "description": "展示你的化妆技巧，通过帮助怪物无缝融入人类社会。保护他们，确保他们的真实身份不被愤怒的民众发现。将怪物变身以隐藏在人群中，确保他们的生存。通过选择肤色、更换眼睛镜片、调整牙齿和添加完美的假发来定制他们的外观，完成他们的人类伪装。但小心——犯错误，你可能成为怪物的下一顿美餐！",
      "instructions": "使用您的鼠标或拖放功能，打造完美造型。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "装扮",
        "女孩",
        "美容",
        "化妆"
      ]
    },
    "zh-TW": {
      "title": "怪物化妝3D",
      "description": "展示你的妝容技巧，透過幫助怪物無縫融入人類社會。保護他們，避免讓他們的真實身份被生氣的暴民發現。將怪物變身，使其能夠隱藏在人海之中，確保他們的生存。透過選擇皮膚顏色、更換眼睛鏡片、調整牙齒和添加完美假髮來量身訂製他們的外觀，完成他們的人類裝扮。但請小心——一旦犯錯，你可能成為怪物的下一頓餐點！",
      "instructions": "使用您的滑鼠或拖放來進行完美變身。",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "打扮",
        "女孩",
        "變裝",
        "妝容"
      ]
    },
    "zh-HK": {
      "title": "怪物化妝3D",
      "description": "展示你的化妝技巧，透過幫助怪物與人類社會融為一體。保護他們，避免他們的真實身份被憤怒的人群發現。將怪物變形，讓他們能夠隱藏在眾人之中，確保他們的生存。透過選擇皮膚顏色、更換眼鏡、調整牙齒和加上完美的假髮來自訂他們的人類裝扮。但小心點——一旦犯錯，你可能成為怪物的下一頓餐！",
      "instructions": "使用鼠標或拖放功能，打造完美變身。",
      "genres": [
        "裝飾服裝"
      ],
      "tags": [
        "打扮",
        "女兒",
        "化妝",
        "妝容"
      ]
    },
    "ja": {
      "title": "モンスターメイク3D",
      "description": "モンスターたちが人間社会に無理やり溶け込むようにする化粧のスキルを見せつけろ。怒った暴徒たちに彼らの正体を隠して守れ。モンスターたちを変身させて目立たなくさせ、生存を確保しろ。肌の色、目のレンズ、歯の調整、完璧なウィッグを追加して人間の仮装を完成させろ。ただし、慎重に行動するんだ—間違ったら、モンスターの次の餌食になるかも！",
      "instructions": "マウスを使用したり、ドラッグ＆ドロップして完璧なメイクオーバーを作成してください。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "ドレッシング",
        "ガールズ",
        "メイクオーバー",
        "メイクアップ"
      ]
    },
    "ko": {
      "title": "몬스터 메이크업 3D",
      "description": "화장 기술을 자랑해 보세요. 몬스터가 인류 사회에 투명하게 녹아들 수 있도록 도와주세요. 그들의 진정한 정체를 화난 민중에게 숨기고 지키세요. 몬스터를 변신시켜 보통 사람들 사이에서 숨겨서 생존을 보장하세요. 피부색을 선택하고, 눈 렌즈를 변경하고, 이를 조정하고, 완벽한 웨이브를 추가하여 인간의 가면을 완성하세요. 하지만 조심하세요. 실수하면 몬스터의 다음 음식이 될 수 있습니다!",
      "instructions": "마우스를 사용하거나 드래그 앤 드롭하여 완벽한 메이크오버를 만들어보세요.",
      "genres": [
        "의상장식"
      ],
      "tags": [
        "의상",
        "소녀",
        "변신",
        "메이크업"
      ]
    },
    "fr": {
      "title": "Maquillage de Monstre 3D",
      "description": "Montrez vos compétences en maquillage en aidant les monstres à se fondre harmonieusement dans la société humaine. Protégez-les en cachant leur véritable identité des foules en colère. Transformez les monstres pour qu'ils se mélangent sans être repérés, assurant ainsi leur survie. Personnalisez leur apparence en choisissant la couleur de la peau, en changeant les lentilles des yeux, en ajustant leurs dents et en ajoutant la perruque parfaite pour compléter leur déguisement humain. Mais soyez prudent — une erreur, et vous pourriez devenir le prochain repas du monstre !",
      "instructions": "Utilisez votre souris ou faites glisser pour réaliser une transformation parfaite.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "vêtements",
        "filles",
        "transformation",
        "maquillage"
      ]
    }
  }
};
